import { STORAGE_KEYS } from 'auth/utils'

export class Auth {
  constructor() {}

  // START: LoginSelectClientForm
  handleCancelClientLoginClick() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('clients')
    localStorage.removeItem('user_id')
    localStorage.removeItem('redirect_after_login')
  }
  // END: LoginSelectClientForm

  // START: LoginSelectApplicationForm
  handleCancelApplicationLoginClick() {
    localStorage.removeItem('client_id')
    localStorage.removeItem('clients')
    localStorage.removeItem('applications')
    localStorage.removeItem('access_token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('redirect_after_login')
  }

  handlePrevStepApplicationLoginClick() {
    localStorage.removeItem('client_id')
    localStorage.removeItem('clients')
    localStorage.removeItem('applications')
  }
  // END: LoginSelectApplicationForm

  // START: LoginSelectSiteForm
  handleCancelSiteLoginClick() {
    localStorage.removeItem('sites')
    localStorage.removeItem('application_id')
    localStorage.removeItem('applications')
    localStorage.removeItem('application_url')
    localStorage.removeItem('client_id')
    localStorage.removeItem('clients')
    localStorage.removeItem('access_token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('redirect_after_login')
  }

  handlePrevStepSiteLoginToClientsClick() {
    localStorage.removeItem('sites')
    localStorage.removeItem('applications')
    localStorage.removeItem('application_id')
    localStorage.removeItem('application_url')
    localStorage.removeItem('clients')
    localStorage.removeItem('client_id')
  }

  handlePrevStepSiteLoginToApplicationsClick() {
    localStorage.removeItem('sites')
    localStorage.removeItem('applications')
    localStorage.removeItem('application_id')
    localStorage.removeItem('application_url')
  }
  // END: LoginSelectSiteForm

  // START: UserMenu
  handleChangeClientClick() {
    localStorage.removeItem('application_id')
    localStorage.removeItem('applications')
    localStorage.removeItem('site_id')
    localStorage.removeItem('sites')
    localStorage.removeItem('application_navigation')
    localStorage.removeItem('application_routing')
  }

  handleChangeApplicationClick() {
    localStorage.removeItem('site_id')
    localStorage.removeItem('sites')
    localStorage.removeItem('application_navigation')
    localStorage.removeItem('application_routing')
  }

  // Manual logout - remove everything
  handleLogoutClick() {
    localStorage.removeItem('application_url')
    localStorage.removeItem('client_id')
    localStorage.removeItem('application_id')
    localStorage.removeItem('site_id')
    localStorage.removeItem('clients')
    localStorage.removeItem('applications')
    localStorage.removeItem('sites')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('i18nextLng')
    localStorage.removeItem('application_navigation')
    localStorage.removeItem('application_routing')
    localStorage.removeItem('application_name')
    localStorage.removeItem('redirect_after_login')
    // Remove cookies
    this.removeCookie('auth')
    this.removeCookie('origin')
    // SSO
    localStorage.removeItem(STORAGE_KEYS.PKCE_CODE_VERIFIER)
    localStorage.removeItem(STORAGE_KEYS.OAUTH_STATE)
    localStorage.removeItem(STORAGE_KEYS.SSO_CLIENT_NAME)
    localStorage.removeItem(STORAGE_KEYS.SSO_ORGANIZATION)
    sessionStorage.removeItem(STORAGE_KEYS.PKCE_CODE_VERIFIER)
    sessionStorage.removeItem(STORAGE_KEYS.OAUTH_STATE)
    sessionStorage.removeItem(STORAGE_KEYS.SSO_CLIENT_NAME)
    sessionStorage.removeItem(STORAGE_KEYS.SSO_ORGANIZATION)
  }

  handleAutomaticLogout() {
    localStorage.removeItem('application_url')
    localStorage.removeItem('client_id')
    localStorage.removeItem('application_id')
    localStorage.removeItem('site_id')
    localStorage.removeItem('clients')
    localStorage.removeItem('applications')
    localStorage.removeItem('sites')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('i18nextLng')
    localStorage.removeItem('application_navigation')
    localStorage.removeItem('application_routing')
    localStorage.removeItem('application_name')
    localStorage.removeItem('redirect_after_login')
    // Remove cookies
    this.removeCookie('auth')
    this.removeCookie('origin')
    // SSO
    localStorage.removeItem(STORAGE_KEYS.PKCE_CODE_VERIFIER)
    localStorage.removeItem(STORAGE_KEYS.OAUTH_STATE)
    localStorage.removeItem(STORAGE_KEYS.SSO_CLIENT_NAME)
    localStorage.removeItem(STORAGE_KEYS.SSO_ORGANIZATION)
    sessionStorage.removeItem(STORAGE_KEYS.PKCE_CODE_VERIFIER)
    sessionStorage.removeItem(STORAGE_KEYS.OAUTH_STATE)
    sessionStorage.removeItem(STORAGE_KEYS.SSO_CLIENT_NAME)
    sessionStorage.removeItem(STORAGE_KEYS.SSO_ORGANIZATION)
  }

  private removeCookie(name: string) {
    // Use the same domain logic as createCookieWithTokenAndOriginUrl
    let path = window.location.hostname
    if (path !== 'localhost') {
      const pathArray = path.split('.')
      path = `.${pathArray[pathArray.length - 2]}.${pathArray[pathArray.length - 1]}`
    }
    // Remove cookie with the same domain and path settings as when it was created
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${path}; Secure; SameSite=None;`
    // Also try to remove without domain (for localhost or edge cases)
    if (path !== 'localhost') {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    }
  }
  // END: UserMenu
}

const auth = new Auth()

export default auth
